const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
] as const;

const shortMonthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
] as const;

const presentLabel = "Present";

const formatMonthValue = (value: string | null, useShort = false) => {
  if (!value || !/^\d{4}-\d{2}$/.test(value)) return "";
  const [year, month] = value.split("-").map(Number);
  const monthIndex = Math.max(0, Math.min(11, month - 1));
  const monthName = useShort
    ? shortMonthNames[monthIndex]
    : monthNames[monthIndex];
  return `${monthName} ${year}`;
};

export const formatMonthYear = (
  value: string | null,
  options?: { useShortMonth?: boolean },
) => {
  return formatMonthValue(value, options?.useShortMonth ?? false);
};

export const formatDateRange = (
  start: string | null,
  end: string | null,
  options?: {
    useShortMonth?: boolean;
    showPresentSuffix?: boolean;
    canBeCurrent?: boolean;
  },
) => {
  const useShortMonth = options?.useShortMonth ?? false;
  const startLabel = formatMonthValue(start, useShortMonth);
  const endLabel = end ? formatMonthValue(end, useShortMonth) : "";
  const resolvedEnd = endLabel || (options?.canBeCurrent ? presentLabel : "");
  if (!startLabel && !resolvedEnd) return "";
  if (!startLabel) return resolvedEnd;
  if (!resolvedEnd) return startLabel;
  return `${startLabel} - ${resolvedEnd}`;
};
